import { Platform } from 'react-native';

/** CSS classes that beat `body.dark-mode input` in global.css. */
export const V2_INPUT_BLEND_CLASS = 'v2-input-blend';
export const V2_INPUT_WELL_CLASS = 'v2-input-well';

export function webInputClassProps(className) {
  if (Platform.OS !== 'web') return {};
  const kind = className === V2_INPUT_BLEND_CLASS ? 'blend' : 'well';
  return {
    className,
    dataSet: { v2Input: kind },
  };
}

const webReset =
  Platform.OS === 'web'
    ? {
        outlineStyle: 'none',
        outlineWidth: 0,
        WebkitAppearance: 'none',
        appearance: 'none',
      }
    : {};

const darkBevel =
  Platform.OS === 'web'
    ? { boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.55), inset 0 -1px 0 rgba(255,255,255,0.07)' }
    : {};

const darkBevelOnWash =
  Platform.OS === 'web'
    ? { boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.35), inset 0 -1px 0 rgba(255,255,255,0.12)' }
    : {};

/** Prevent native/browser input backgrounds from overriding card styling (especially in dark mode). */
export const transparentTextInputStyle =
  Platform.OS === 'web'
    ? {
        backgroundColor: 'transparent',
        ...webReset,
        boxShadow: 'none',
      }
    : {
        backgroundColor: 'transparent',
      };

/** Label / inline text fields: no chrome, inherit the card. */
export const inlineBlendInputStyle = {
  ...transparentTextInputStyle,
  backgroundColor: 'transparent',
  borderWidth: 0,
};

/**
 * Numeric / boxed fields.
 * Light: sunk well. Dark: match the card and carve a bevel instead of a navy box.
 */
export function fieldWellStyle(pal, isDarkMode) {
  if (!isDarkMode) {
    return {
      ...webReset,
      backgroundColor: pal.sunk,
      borderColor: pal.lineSoft,
    };
  }
  return {
    ...webReset,
    backgroundColor: 'rgba(0,0,0,0.2)',
    borderTopColor: 'rgba(0,0,0,0.62)',
    borderRightColor: 'rgba(255,255,255,0.09)',
    borderBottomColor: 'rgba(255,255,255,0.11)',
    borderLeftColor: 'rgba(0,0,0,0.5)',
    ...darkBevel,
  };
}

/** Notes and other fields sitting on a tinted panel rather than a card. */
export function insetBlendStyle(isDarkMode, pal, { wellFill } = {}) {
  if (!isDarkMode) {
    return {
      ...webReset,
      backgroundColor: wellFill || pal.sunk,
      borderColor: pal.lineSoft,
    };
  }
  return {
    ...webReset,
    backgroundColor: 'transparent',
    borderTopColor: 'rgba(0,0,0,0.45)',
    borderRightColor: 'rgba(255,255,255,0.12)',
    borderBottomColor: 'rgba(255,255,255,0.14)',
    borderLeftColor: 'rgba(0,0,0,0.35)',
    ...darkBevelOnWash,
  };
}
